import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Tags } from "lucide-react";
import { usePermissions } from "../../utilis/PermissionsContext";
import CompanyFormsPageHeader from "./CompanyFormsPageHeader";
import CompanyFormsEmptyState from "./CompanyFormsEmptyState";
import CompanyFormsCategoriesPanel from "./CompanyFormsCategoriesPanel";
import CompanyFormsAddCategoryModal from "./CompanyFormsAddCategoryModal";
import { useCompanyFormCategories } from "./useCompanyFormCategories";
import {
  COMPANY_FORMS_MODULE_CONTENT,
  COMPANY_FORMS_MODULE_PAGE_SHELL,
  COMPANY_FORMS_ROOT,
  MODULE_PAGE_SHELL_STYLE,
  canManageCompanyFormCategories,
} from "./companyFormConstants";

export default function CompanyFormsCategories() {
  const {
    categories,
    categoriesLoading,
    createCategory,
    updateCategory,
    deleteCategory,
  } = useCompanyFormCategories();

  const { permissions, loading: permissionsLoading } = usePermissions();
  const [addingCategory, setAddingCategory] = useState(false);

  const canManage = canManageCompanyFormCategories(permissions);

  if (!permissionsLoading && permissions && !canManage) {
    return (
      <div className={COMPANY_FORMS_ROOT}>
        <CompanyFormsPageHeader
          icon={Tags}
          title="Document categories"
          subtitle="Organize labels used when uploading and filtering documents."
        />
        <div className={COMPANY_FORMS_MODULE_PAGE_SHELL} style={MODULE_PAGE_SHELL_STYLE}>
          <div className={`${COMPANY_FORMS_MODULE_CONTENT} py-6`}>
            <CompanyFormsEmptyState
              icon={Tags}
              title="Document access required"
              description="Upload or approve permission is required to manage categories."
            >
              <Link
                to="/company-forms"
                className="company-forms-btn inline-flex rounded-lg bg-[#007BFF] px-4 py-2 text-xs font-semibold text-white no-underline hover:bg-[#0069d9]"
              >
                View documents
              </Link>
            </CompanyFormsEmptyState>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={COMPANY_FORMS_ROOT}>
      <CompanyFormsPageHeader
        icon={Tags}
        title="Document categories"
        subtitle="Organize labels used when uploading and filtering documents."
        actions={
          <button
            type="button"
            onClick={() => setAddingCategory(true)}
            className="company-forms-btn inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-[#007BFF] px-3.5 py-2 text-xs font-semibold text-white shadow-sm hover:bg-[#0069d9]"
          >
            <Plus size={14} strokeWidth={2} aria-hidden />
            Add category
          </button>
        }
      />

      <CompanyFormsAddCategoryModal
        open={addingCategory}
        onClose={() => setAddingCategory(false)}
        onCreate={createCategory}
      />

      <div className={COMPANY_FORMS_MODULE_PAGE_SHELL} style={MODULE_PAGE_SHELL_STYLE}>
        <div className={COMPANY_FORMS_MODULE_CONTENT}>
          {categoriesLoading ? (
            <div className="rounded-xl border border-[#E5ECF5] bg-white px-4 py-10 text-center text-sm text-[#64748B] shadow-[0_1px_2px_rgba(20,33,61,0.05)]">
              Loading categories…
            </div>
          ) : (
            <CompanyFormsCategoriesPanel
              categories={categories}
              canManage={canManage}
              onCreate={createCategory}
              onUpdate={updateCategory}
              onDelete={deleteCategory}
              fullPage
            />
          )}
        </div>
      </div>
    </div>
  );
}
